import * as type from './types';

export function getProfileData(data) {
    return {
        type: type.GET_PROFILE_DATA_REQUESTED,
        data: data,
    }
}
export function updateProfileSubscriptionStatus(isProProvider) {
    return {
        type: type.UPDATE_PROFILE_SUBSCRIPTION_STATUS,
        isProProvider: isProProvider,
    }
}
